//Set default values if not passed from cms
export function setDefaultValues(model) {
    model.titleForFAO = model.titleForFAO || "Let's find a tax preparation office for you";

    model.findMyNearestButton = model.findMyNearestButton || '<img src="/img/location_icon.svg" class="mr-2" alt=""><span>Find my nearest</span>';

    model.inputLabelFAO = model.inputLabelFAO || "Enter ZIP Code";

    model.inputPlaceholderFAO = model.inputPlaceholderFAO || "ZIP Code";

    model.zipSearchButtonFAO = model.zipSearchButtonFAO || '<img src="/img/zoom_icon.svg" alt="Search Offices">';

    model.noResultErrorFAO = model.noResultErrorFAO || "Sorry, we can't find any results for ";

    model.officeResltsTitleFAO = model.officeResltsTitleFAO || "How about these tax preparation offices?";

    model.geolocationDeniedErrorFAO = model.geolocationDeniedErrorFAO || "You denied the request for Geolocation!";
        
    model.viewMoreButtonFAO = model.viewMoreButtonFAO || '<img src="/img/light_purple_arrow_icon.svg" class="mr-2" alt="">View more';

    return model;
}
